module.exports = __webpack_public_path__ + "static/media/closeCircle.e4e6ae80.svg";